import { Link } from "react-router-dom";
import NavBar from "../components/NavBar";
import classNames from "classnames";

export default function PublicContext({ children, className }) {
	return (
		<div className={classNames("min-h-screen bg-gray-200 p-4", className)}>
			<NavBar />
			{children}
			<footer className="bg-white shadow-lg rounded-lg text-black py-8 mt-10 ">
				<div className="container mx-auto px-4 flex flex-col md:flex-row items-center md:justify-between">
					{/* Logo e Informazioni */}
					<div className="flex items-center space-x-4 mb-4 md:mb-0">
						<img
							src="/images/logo.svg"
							alt="Logo Protezione Civile"
							className="h-16 w-48 object-contain"
						/>
						<div>
							<p className="text-lg font-semibold">Protezione Civile ANA Atri</p>
							<p className="text-sm text-gray-600">ANA Sez. Abruzzi Gruppo di Atri</p>
							<p className="text-sm text-gray-600">Volontariato Protezione Civile</p>
						</div>
					</div>

					<div className="text-center md:text-right space-y-2">
						<p className="text-sm text-gray-600">© 2025 Tutti i diritti riservati.</p>
						<p className="text-sm text-gray-600">
							<a href="info@ProtezioneCivileAnaAtri.it" className="hover:underline">
								info@ProtezioneCivileAnaAtri.it
							</a>
						</p>
						<p className="text-sm text-gray-600">
							Telefono:{" "}
							<a href="tel:+3908577881" className="hover:underline">
								+39 085 77 881
							</a>
						</p>
						<p className="text-sm text-gray-600">
							<Link to="/privacy-policy" className="hover:underline">
								Privacy Policy
							</Link>
						</p>
					</div>
				</div>
			</footer>
		</div>
	);
}
